import btn from './btn.vue';
import qklBtn from './qkl-buttons.vue';
const btns = {
    btn,
    qklBtn
}

export default btns;



// WEBPACK FOOTER //
// ./src/components/inc/btns/index.js